'use client'

import { signIn, type SignInAuthorizationParams } from 'next-auth/react'
import { type JSX, type PropsWithChildren } from 'react'

import styles from './styles.module.css'

interface Props {
  providerId: string
  authorizationParams?: SignInAuthorizationParams
}

const LoginButton = ({ providerId, children, authorizationParams }: PropsWithChildren<Props>): JSX.Element => {
  return (
    <button
      className={`${styles['button-login']}`}
      data-test={providerId}
      onClick={() => {
        void (async () => {
          await signIn(providerId, {}, authorizationParams)
        })()
      }}
    >
      {children}
    </button>
  )
}

export default LoginButton
